export default "__VITE_ASSET__CVfOd0bx__"